import { render, staticRenderFns } from "./AuthorizationError.vue?vue&type=template&id=3ae027f1&scoped=true"
import script from "./AuthorizationError.vue?vue&type=script&lang=js"
export * from "./AuthorizationError.vue?vue&type=script&lang=js"
import style0 from "./AuthorizationError.vue?vue&type=style&index=0&id=3ae027f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae027f1",
  null
  
)

export default component.exports